import {
  faArrowLeft,
  faCamera,
  faCircleCheck,
  faXmark,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  createMatchingRequest,
  editMatch,
  editMatchAll,
  getMatchingCategory,
  getMatchingSubCategory,
  getMatchingSubDetailCategory,
} from "firebase_/firebase_function/matching";
import { useEffect, useMemo, useRef, useState } from "react";
import ReactModal from "react-modal";
import { emptyCheck } from "util/function/function";
import CircleCheckIcon from "assets/dialog_assets/circleCheck.svg";
import { useUser } from "util/context/user_context";
import OnlyLoadingScreen from "components/loading_screen";
import { useParams } from "react-router-dom";
import OnlyConfirmDialog from "components/onlyConfirm_dialog";
import { Dialog } from "@mui/material";

const ExpertCategoryDialog = ({
  open,
  onSubmit,
  setIsDialogOpen,
  isEdit,
  data,
  onClose,
}) => {
  const [categoryList, setCategoryList] = useState([]);
  const [num, setNum] = useState(null);
  const [status, setStatus] = useState(0);

  // 카테고리 불러오기
  useEffect(() => {
    const fetchData = async () => {
      const data = await getMatchingCategory();
      // 카테고리 목록을 업데이트합니다.
      setCategoryList(data);
    };

    fetchData();
  }, [status]);

  // 모달 닫기 함수
  const closeModal = () => {
    setIsDialogOpen(false);
  };

  const closeModal2 = (tag) => {
    onClose(tag);
    setIsDialogOpen(false);
  };

  return (
    <>
      <Dialog
        open={open}
        onClose={closeModal}
        sx={{
          "& .MuiPaper-root": {
            borderRadius: 3,
            minWidth: "auto",
            maxWidth: "100%",
          },
        }}
      >
        <div
          style={{
            borderBottom: "1px solid #E5E7EB",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <div
            style={{
              display: "flex",
              gap: "24px",
              alignItems: "center",
              padding: "18px",
            }}
          >
            <div className="f18_1F2937_W500">전문 분야 선택</div>
          </div>
          <button
            type="button"
            onClick={closeModal}
            style={{ padding: "18px 18px" }}
          >
            <FontAwesomeIcon icon={faXmark} size="xl" color="#6B7280" />
          </button>
        </div>
        <div
          className="lg:grid-cols-3 md:grid-cols-2 grid-cols-2"
          style={{
            display: "grid",
            gap: "16px",
            flexWrap: "wrap",
            padding: "18px",
          }}
        >
          {categoryList
            .filter((category) => category.name !== "기타")
            .map((category, index) => (
              <button
                key={index}
                className={`hover:bg-black/5 transition-all active:bg-black/10 f16_1F2937_W500 w-[120px] sm:w-[240px]`}
                style={{
                  height: "84px",
                  border: "2px solid #E5E7EB",
                  borderRadius: "12px",
                  cursor: "pointer",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  backgroundColor: num === index ? "#98B88A" : "",
                }}
                onClick={() => {
                  closeModal2(category.tag);
                }}
              >
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "4px",
                    padding: "16px",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  {status < 1 && (
                    <img
                      src={`/${category.icon}`}
                      alt={category.name}
                      style={{
                        width: "24px",
                        height: "24px",
                        borderRadius: "12px",
                        objectFit: "cover",
                      }}
                      draggable="false"
                    />
                  )}
                  <div className="f16_1F2937_W500">{category.name}</div>
                </div>
              </button>
            ))}
        </div>
      </Dialog>
    </>
  );
};

export default ExpertCategoryDialog;
